export default __webpack_public_path__ + "static/media/mTop_1_p3.8d422196.jpeg";